<div class="container-fluid">
  <div class="row manageaccount mt-3">
    <div class="col-md-12 my-auto">
      <div class="d-flex align-items-baseline justify-content-between">
        <h1 class="fs-4 fw-bold mb-0">
          {{
            isEditMode ? "Edit Own Vehicle Expense" : "Add Own Vehicle Expense"
          }}
        </h1>

        <button
          class="btn btn-dark btn-sm"
          mat-raised-button
          matTooltip="Back"
          matTooltipPosition="left"
          (click)="backTo()"
        >
          <i class="fa-solid fa-arrow-left"></i>
        </button>
      </div>

      <nav class="breadcrumbMaine" aria-label="breadcrumb mb-0">
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item" (click)="backTo()">
            Own Vehicle Expense
          </li>
          <li class="breadcrumb-item active" aria-current="page">
            Add Own Vehicle Expense
          </li>
        </ol>
      </nav>
    </div>
  </div>

  <div class="row mt-3">
    <div class="col-xl-12">
      <form
        [formGroup]="addOwnVicheleMaintenanceForm"
        (ngSubmit)="submitForm()"
        enctype="multipart/form-data"
      >
        <div class="contentbox">
          <div class="row account mb-3">
            <!-- Vehicle / Trip -->
            <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
              <div class="form-group accountsinp mb-3">
                <label for="">Vehicle<sup class="text-danger">*</sup></label>

                <input
                  type="text"
                  class="form-control shadow-none"
                  formControlName="vehicle"
                  [matAutocomplete]="autoVehicle"
                  placeholder="Select Vehicle"
                />

                <mat-autocomplete
                  autoActiveFirstOption
                  #autoVehicle="matAutocomplete"
                  [displayWith]="displayVehicle"
                >
                  <mat-option
                    *ngFor="let v of filteredVehicles | async"
                    [value]="v"
                  >
                    {{ v.vehicle_no }}
                  </mat-option>
                </mat-autocomplete>
              </div>
            </div>

            <!-- Vehicle Type (Auto populated) -->
            <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
              <div class="form-group accountsinp mb-3">
                <label>Vehicle Type</label>
                <input
                  type="text"
                  class="form-control shadow-none"
                  formControlName="vehicleType"
                  placeholder="Vehicle Not Selected"
                  readonly
                />
              </div>
            </div>

            <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
              <div class="form-group accountsinp mb-3">
                <label for=""
                  >Expense Date<sup class="text-danger">*</sup></label
                >
                <input
                  type="date"
                  class="form-control shadow-none"
                  formControlName="expenseDate"
                />
              </div>
            </div>

            <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
              <div class="form-group accountsinp mb-3">
                <label for="">Location</label>
                <input
                  placeholder="Enter Location"
                  type="text"
                  class="form-control shadow-none"
                  formControlName="location"
                />
              </div>
            </div>

            <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
              <div class="form-group accountsinp mb-3">
                <label for="">Start Meter Reading</label>
                <input
                  placeholder="Enter Start Meter Reading"
                  type="number"
                  class="form-control shadow-none"
                  formControlName="startMeterReading"
                />
              </div>
            </div>

            <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
              <div class="form-group accountsinp mb-3">
                <label for="">End Meter Reading</label>
                <input
                  placeholder="Enter End Meter Reading"
                  type="number"
                  class="form-control shadow-none"
                  formControlName="endMeterReading"
                />
              </div>
            </div>

            <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
              <div class="form-group accountsinp mb-3">
                <label for="">Total Kms</label>
                <input
                  type="number"
                  class="form-control shadow-none"
                  formControlName="totalKms"
                  placeholder="Auto Calculated"
                  readonly
                />
              </div>
            </div>

            <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
              <div class="form-group accountsinp mb-3">
                <label for="">Loader Advance</label>
                <input
                  placeholder="Enter Loader Advance Amount"
                  type="number"
                  class="form-control shadow-none"
                  formControlName="loaderAdvance"
                />
              </div>
            </div>

            <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
              <div class="form-group accountsinp mb-3">
                <label for="">Driver Advance</label>
                <input
                  placeholder="Enter Driver Advance Amount"
                  type="number"
                  class="form-control shadow-none"
                  formControlName="driverAdvance"
                />
              </div>
            </div>

            <!-- Police & Other -->
            <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
              <div class="form-group accountsinp mb-3">
                <label for="">Police Amount</label>
                <input
                  placeholder="Enter Fine Amount"
                  type="number"
                  class="form-control shadow-none"
                  formControlName="policeAmount"
                />
              </div>
            </div>
            <!-- Fuel  -->
            <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
              <div class="form-group accountsinp mb-3">
                <label for="">Fuel Expense (CNG/Diesel)</label>
                <input
                  placeholder="Enter Fuel Expense Amount"
                  type="number"
                  class="form-control shadow-none"
                  formControlName="fuelExpense"
                />
              </div>
            </div>

            <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
              <div class="form-group accountsinp mb-3">
                <label for="">Other Amount</label>
                <input
                  min="0"
                  placeholder="Enter Other Amount"
                  type="number"
                  class="form-control shadow-none"
                  formControlName="other"
                />
              </div>
            </div>

            <div class="col-lg-6 col-xl-6 col-sm-12 col-12 col-md-6">
              <div class="form-group accountsinp mb-3">
                <label for="">Other Description</label>
                <input
                  placeholder="Enter Other Amount Description"
                  type="text"
                  class="form-control shadow-none"
                  formControlName="otherDescription"
                />
              </div>
            </div>

            <!-- Total Amount -->
            <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
              <div class="form-group accountsinp mb-3">
                <label for="">Total Amount</label>
                <input
                  type="number"
                  class="form-control shadow-none"
                  formControlName="totalAmount"
                  placeholder="Auto Calculated"
                  readonly
                />
              </div>
            </div>
            <!-- Attachment -->
            <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
              <div class="form-group accountsinp mb-3">
                <label>Attachment</label>
                <input
                  type="file"
                  class="form-control shadow-none"
                  multiple
                  (change)="onFileChange($event)"
                />
              </div>

              <!-- Selected / Existing Attachments -->
              <ul class="attachment-list">
                <!-- Existing attachments -->
                <li
                  *ngFor="let file of existingAttachments"
                  class="attachment-item"
                >
                  <a
                    [href]="apiUrl + '/' + file"
                    target="_blank"
                    class="attachment-name"
                  >
                    {{ file.split("/").pop() }}
                  </a>

                  <button
                    type="button"
                    class="attachment-remove"
                    (click)="removeExistingAttachment(file)"
                  >
                    ✕
                  </button>
                </li>

                <!-- New files -->
                <li
                  *ngFor="let file of filesToUpload; let i = index"
                  class="attachment-item"
                >
                  <span class="attachment-name">{{ file.name }}</span>

                  <button
                    type="button"
                    class="attachment-remove"
                    (click)="removeNewAttachment(i)"
                  >
                    ✕
                  </button>
                </li>
              </ul>
            </div>

            <!-- Buttons -->
            <div class="col-md-12 text-end">
              <button
                class="btn btn-outline-dark"
                type="button"
                (click)="resetForm()"
                mat-raised-button
              >
                Reset
              </button>
              <button class="btn btn-dark ms-2" type="submit">
                {{ isEditMode ? "Update" : "Save" }}
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
<ngx-spinner
  bdColor="rgba(51,51,51,0.8)"
  size="medium"
  color="#fff"
  type="ball-scale-multiple"
>
  <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>
